/**
 * Os quatro itens da lista de pacientes.
 */
export const PATIENT_BENEFITS = [
  { label: 'Apoio individualizado' },
  { label: 'Acompanhamento contínuo' },
  { label: 'Garantia de segurança' },
  { label: 'Melhor adaptação ao tratamento' }
]

export const PROFESSIONAL_BENEFITS = [
  { label: 'Acesso a toda a evolução do tratamento do seu paciente' },
  { label: 'Monitoramento personalizado' },
  { label: 'Maior adesão terapêutica' },
  { label: 'Reforço da posologia e orientações, sempre alinhado com a conduta estabelecida pelo profissional' }
]

/** "O que o Cuida oferece" — cinco itens. */
export const CUIDA_OFFERINGS = [
  {
    title: 'Time de enfermagem dedicado',
    description: 'Um enfermeiro acompanha sua evolução do início ao fim do tratamento.'
  },
  {
    title: 'Assistência inteiramente gratuita',
    description: 'Nenhum custo adicional: o acompanhamento faz parte do seu tratamento.'
  },
  {
    title: 'Sincronia com o prescritor',
    description: 'Cada orientação é alinhada com o médico ou cirurgião-dentista responsável pela sua prescrição.'
  },
  {
    title: 'Suporte para dúvidas do dia a dia',
    description:
      'Conte com o time de enfermagem para tirar dúvidas durante todo o tratamento, sempre em linha com as diretrizes do médico ou cirurgião-dentista.'
  },
  {
    title: 'Dados tratados com privacidade',
    description: 'Suas informações são usadas apenas para organizar seu acompanhamento.'
  }
]

export const CUIDA_FAQ_ITEMS = [
  {
    question: 'O que é o Cuida?',
    answer:
      'É o serviço de acompanhamento da Cannect: um time de enfermagem acompanha você durante todo o tratamento, em sincronia com o médico ou cirurgião-dentista prescritor.'
  },
  {
    question: 'O acompanhamento tem algum custo?',
    answer:
      'Não. A assistência do time de enfermagem é inteiramente gratuita para quem está em tratamento pela Cannect.'
  },
  {
    question: 'Como funciona o acompanhamento pela enfermagem?',
    answer:
      'O time de enfermagem acompanha sua evolução durante o tratamento e atua em total conjunto e sincronia com o médico ou cirurgião-dentista prescritor.'
  },
  {
    question: 'O Cuida substitui uma consulta médica?',
    answer:
      'Não. O acompanhamento de enfermagem apoia o tratamento prescrito; decisões clínicas continuam sendo feitas pelo médico ou cirurgião-dentista responsável.'
  },
  {
    question: 'Como falo com o time de enfermagem?',
    answer:
      'Você pode falar com a equipe pelos canais de acompanhamento da Cannect, disponíveis para quem já iniciou o tratamento.'
  }
]
